import { ResponsivePie } from "@nivo/pie";

const PieChart = ({ data }) => {
  return (
    <ResponsivePie
      data={data}
      margin={{ top: 30, right: 100, bottom: 30, left: -100 }}
      startAngle={-180}
      innerRadius={0.75}
      padAngle={1}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      colors={[
        "var(--pie-chart-first-color)",
        "var(--pie-chart-second-color)",
        "var(--pie-chart-third-color)",
        "var(--pie-chart-fourth-color)",
      ]}
      borderColor={{
        from: "color",
        modifiers: [["darker", "0.2"]],
      }}
      enableArcLinkLabels={false}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="var(--pie-chart-label-text)"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      enableArcLabels={false}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{
        from: "color",
        modifiers: [["darker", "2"]],
      }}
      legends={[
        {
          anchor: "right",
          direction: "column",
          justify: true,
          translateX: 78,
          translateY: 0,
          itemWidth: 30,
          itemHeight: 40,
          itemsSpacing: 5,
          symbolSize: 15,
          itemDirection: "right-to-left",
        },
      ]}
    />
  );
};

export default PieChart;
